import Vue from 'vue';

import App from './App.vue';
import router from './router';
import store from './store';

import './filters';

import './registerServiceWorker';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  beforeCreate() {
    // Reload notes when the storage provider preference is updated
    this.$store.subscribe(mutation => {
      if (mutation.type === 'preferences/set' && mutation.payload.key === 'STORAGE_PROVIDER') {
        this.$store.dispatch('createStorageProvider');
      }
    });

    this.$store.dispatch('preferences/load');

    Vue.prototype.$modal = {
      show: args => this.$store.dispatch('modals/show', args),
      dismiss: () => this.$store.dispatch('modals/dismiss'),
    };

    // Remove unused images from db on page unload
    window.addEventListener('beforeunload', async () => {
      const currentNote = this.$store.state.notes.current;
      await this.$store.dispatch('notes/deleteUnusedNoteImages', { note: currentNote });
    });
  },
  render: h => h(App),
}).$mount('#app');
